

exports.__esModule = true;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

require('pages/xo-sidepage-add-card/route');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Route.extend('$xoTopupFundingRoute', {
    path: 'topupFunding',
    directive: _directive2['default'],
    children: [{
        name: '$SidepageAddCardRoute',
        attributes: {
            token: 'token',
            callbacks: 'addCardCallbacks'
        }
    }]
});


_index.$Route;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/topup/topup-funding/route.js
// module id = ./components/xo-wallet-components/src/topup/topup-funding/route.js
// module chunks = 1